import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import {APIv1} from "../../../../../api";
import AnalyticsCard from "../BaseCard/AnalyticsCard";

const S2PCountCard = ({startPeriod, endPeriod, handleChangePeriod, provider}) => {
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            let url = (startPeriod && endPeriod) ? `/scan2pay/analysis/transactions/counts/?p=${provider}&start_period=${startPeriod}&end_period=${endPeriod}` : '/scan2pay/analysis/transactions/counts/payme/'
            const response = await APIv1.get(url, {
                headers: {
                    Authorization: `Token ${userData.token}`,
                },
            });
            const responseData = response.data;

            setData({
                createdCount: responseData?.created,
                successCount: responseData?.success,
                failureCount: responseData?.failure,
                tipsCount: responseData?.tips,
                successRatio: responseData?.success_ratio,
            });

        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }, [userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        if (!userData.token) return;

        fetchData()
    }, [userData.token, startPeriod, endPeriod])


    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    return (
        <>
            <AnalyticsCard
                t={t}
                title={t("pages.scan2pay.analysis.title1")}
                created={data.createdCount}
                success={data.successCount}
                failure={data.failureCount}
                tips={data.tipsCount}
                successPercent={data.successRatio}
                isShowDate={true}
                handleChangePeriod={handleChangePeriod}
            />
        </>
    )
}

export default S2PCountCard;